import React from "react";
import Link from "@mui/material/Link";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import { Slide } from "@mui/material";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Container,
} from "@mui/material";

const FAQSection = () => {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(null); // Store only one expanded panel
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null); // Update state with the expanded panel or close it
  };

  const faqs = [
    {
      question: "Who can apply for the Loan",
      answer: "Any conscious person aged 18 and above.",
    },
    {
      question: "What information do I need to open an account",
      answer: (
        <ul>
          <li>NIDA number</li>
          <li>Active phone number</li>
        </ul>
      ),
    },
    {
      question: "How long does the loan application process take",
      answer:
        "Not more than 24 hours. If your loan application takes more than 24 hours, please contact us to resolve.",
    },
    {
      question: "What maximum loan amount can I get",
      answer: "You can get up to 500,000/= TZS.",
    },
    {
      question: "What conditions are required for a loan applicant?",
      answer:
        "SAVA checks age, repayment history, and ambassador’s recommendation are required for any loan applicant.",
    },
    {
      question: "What happens if I do not repay the loan on time?",
      answer:
        "If you fail to pay on time, you will incur an automatic rollover fee. Also, your future loan amount will be reduced.",
    },
    {
      question: "How do I repay my loan?",
      answer: (
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          <li>1. Open your mobile USSD menu.</li>
          <li>2. Choose paybill (#5 for Airtel, #4 for Vodacom and Tigo).</li>
          <li>3. Enter company number (101010).</li>
          <li>
            4. Enter reference number (your Sava account registration number).
          </li>
          <li>5. Enter your repayment amount.</li>
          <li>6. Enter your password to authorize payment.</li>
        </ul>
      ),
    },
  ];

  return (

       <Slide direction="down" in={true} timeout={500}>
    <Container
      sx={{ maxWidth: "1300px", marginTop: { xs: "40px", md: "20px" } }}>
      <Box sx={{ width: "100%" }}>
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Frequently Asked Questions
        </Typography>
        {faqs.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{ margin: "0px" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}d-content`}
              id={`panel${index}d-header`}
              sx={{ backgroundColor: "white" }}>
              <Typography
                component="span"
                variant="subtitle2"
                color="black"
                sx={{ fontWeight: "bold" }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "white" }}>
              <Typography
                color="black"
                variant="body2"
                gutterBottom
                sx={{ maxWidth: { sm: "100%", md: "70%" }, marginTop: "0px" }}>
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
    </Slide>
  );
};

export default FAQSection;
